module.exports = __webpack_public_path__ + "img/MarkerVaste.2a3935b0.svg";